var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { getUIMap, deserializeDuration } from '../UIJsonParser/transformations';
import * as CONSTS from '../constants/dropdowns';
import EmptyStateIcon from '../images/EmptyStateIcon';
import '../assets/styles/index.scss';
import { firstToUpperCase } from '../utils/helpers';
var FullDateFormatOptions = {
    dateStyle: 'long',
    timeStyle: 'short',
};
var ShortDateFormatOptions = {
    dateStyle: 'short',
    timeStyle: 'short',
};
var LOCATION_ATTR_METADATA_MAP = {
    inArea: {
        areaType: 'name',
        precision: 'precise',
        opString: 'is in the location',
    },
    inApproximateArea: {
        areaType: 'name',
        precision: 'approx',
        opString: 'is around the location',
    },
    inAreaWithLabel: {
        areaType: 'label',
        precision: 'precise',
        opString: ' any location with the label',
    },
    inLocationWithLabel: {
        areaType: 'label',
        precision: 'approx',
        opString: 'is around a location with the label',
    },
};
var PLACEHOLDERSTR = '{{ Placeholder }}';
export var RulePreview = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, responseJSON = _a.responseJSON, locations = _a.locations, contextPlugins = _a.contextPlugins, historicalQueries = _a.historicalQueries;
    var DEFAULT_CLASS = 'rule-preview';
    var uiBlocks = (_b = getUIMap(responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload, contextPlugins)) === null || _b === void 0 ? void 0 : _b.uiBlocks;
    var locationNameMap = (function () {
        var map = {};
        locations === null || locations === void 0 ? void 0 : locations.forEach(function (location) {
            var _a;
            map[location.id] = (_a = location === null || location === void 0 ? void 0 : location.name) !== null && _a !== void 0 ? _a : '<Unknown>';
        });
        return map;
    })();
    var pluginMap = (function () {
        var map = {};
        contextPlugins === null || contextPlugins === void 0 ? void 0 : contextPlugins.forEach(function (plugin) {
            var e_1, _a;
            var _b, _c;
            map[plugin.uid] = {
                pluginName: plugin.name,
                attributes: {},
            };
            try {
                for (var _d = __values(Object.entries(plugin.values)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var _f = __read(_e.value, 2), attributeKey = _f[0], attributeValue = _f[1];
                    var attributeUid = attributeValue.uid;
                    var attributeName = attributeValue.name || attributeUid.slice(attributeUid.lastIndexOf('.') + 1);
                    map[plugin.uid].attributes[attributeKey] = {
                        attributeName: attributeName,
                        paramKeys: (_c = (_b = attributeValue.parameters) === null || _b === void 0 ? void 0 : _b.map(function (param) { return param.key; })) !== null && _c !== void 0 ? _c : [],
                    };
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        return map;
    })();
    // not sure if this needs to display the attribute (even if the plugin has a placeholder)
    var getAttributeName = function (pluginKey, attrKey, isLocation, hasPlaceHolder) {
        var _a, _b, _c;
        if (hasPlaceHolder === void 0) { hasPlaceHolder = false; }
        if (isLocation)
            return 'User';
        if (pluginKey.includes('{{P}}'))
            return '';
        if (attrKey === '{{P}}')
            return PLACEHOLDERSTR;
        if (hasPlaceHolder)
            return PLACEHOLDERSTR;
        return (_c = (_b = (_a = pluginMap[pluginKey.join('.')]) === null || _a === void 0 ? void 0 : _a.attributes[attrKey]) === null || _b === void 0 ? void 0 : _b.attributeName) !== null && _c !== void 0 ? _c : '';
    };
    // not sure if this needs to display plugin name if only the plugin string's
    // second (provider) block is a placeholder
    var getPluginName = function (pluginKey, isLocation) {
        var _a, _b;
        if (isLocation)
            return '';
        if (pluginKey.includes('{{P}}'))
            return PLACEHOLDERSTR;
        return (_b = (_a = pluginMap[pluginKey.join('.')]) === null || _a === void 0 ? void 0 : _a.pluginName) !== null && _b !== void 0 ? _b : '';
    };
    var getOperatorString = function (nodeId, op, valueType, hasPlaceHolder, historicalValue, locationMetadata) {
        var _a, _b, _c, _d, _e, _f;
        if (hasPlaceHolder === void 0) { hasPlaceHolder = false; }
        if (hasPlaceHolder)
            return PLACEHOLDERSTR;
        // does not support negative statements for location yet
        if (locationMetadata)
            return locationMetadata.opString;
        if (historicalValue) {
            return (_a = CONSTS.INT_FLOAT_STATEMENTS.find(function (option) {
                return option.exp === op &&
                    option.type === 'historical' &&
                    option.negate === historicalValue.negate &&
                    option.function === historicalValue.functionValue;
            })) === null || _a === void 0 ? void 0 : _a.name.toLowerCase();
        }
        switch (valueType) {
            case 'bool':
                return (_b = CONSTS.BOOL_STATEMENTS.find(function (option) { return option.value === op; })) === null || _b === void 0 ? void 0 : _b.name.toLowerCase();
            case 'dateTime':
                return (_c = CONSTS.DATE_TIME_STATEMENTS.find(function (option) { return option.value === op; })) === null || _c === void 0 ? void 0 : _c.name.toLowerCase();
            case 'float':
                return (_d = CONSTS.INT_FLOAT_STATEMENTS.find(function (option) { return option.value === op; })) === null || _d === void 0 ? void 0 : _d.name.toLowerCase();
            case 'int':
                return (_e = CONSTS.INT_FLOAT_STATEMENTS.find(function (option) { return option.value === op; })) === null || _e === void 0 ? void 0 : _e.name.toLowerCase();
            case 'string':
                return (_f = CONSTS.STRING_STATEMENTS.find(function (option) { return option.value === op; })) === null || _f === void 0 ? void 0 : _f.name.toLowerCase();
        }
    };
    var getConditionValue = function (value, valueType, hasPlaceHolder, locationMetadata, rules) {
        if (hasPlaceHolder === void 0) { hasPlaceHolder = false; }
        if (hasPlaceHolder)
            return PLACEHOLDERSTR;
        if (locationMetadata)
            return getLocationValue(rules !== null && rules !== void 0 ? rules : [], locationMetadata.areaType);
        return valueType === 'dateTime'
            ? new Date(parseInt(value) * 1000).toLocaleString(undefined, FullDateFormatOptions)
            : value !== null && value !== void 0 ? value : '';
    };
    var getLocationMetadata = function (attributeName, value) {
        var metadata = LOCATION_ATTR_METADATA_MAP[attributeName];
        if (!metadata)
            return;
        if (attributeName !== 'inAreaWithLabel')
            return metadata;
        var opStringPrefix = value === 'entry' ? 'enters ' : 'leaves ';
        return __assign(__assign({}, metadata), { opString: opStringPrefix + metadata.opString });
    };
    var getLocationValue = function (rules, locationType) {
        var locations = [];
        rules.forEach(function (rule) {
            var _a, _b, _c;
            var locationParam = (_b = (_a = rule.parameterValues) === null || _a === void 0 ? void 0 : _a.slice(-1)) === null || _b === void 0 ? void 0 : _b[0];
            if (!locationParam)
                return;
            if (locationType === 'name') {
                locations.push((_c = locationNameMap[locationParam]) !== null && _c !== void 0 ? _c : '<Unknown>');
            }
            else if (locationType === 'label') {
                locations.push(locationParam.toString());
            }
        });
        return locations.map(function (location, i) {
            if (locations.length === 1)
                return location;
            var comma = locations.length > 2 && i !== locations.length - 1 ? ',' : '';
            var space = i > 0 ? ' ' : '';
            var conjunction = i !== 0 && i === locations.length - 1 ? (locationType === 'name' ? 'or ' : 'and ') : '';
            // futureproof in case we need to be able to change if we want to bold
            // certain items
            return "".concat(space).concat(conjunction).concat(location).concat(comma);
        });
    };
    var getHistoricalString = function (historicalValue) {
        var _a;
        if (!historicalValue)
            return '';
        var operator = ((_a = CONSTS.LIMIT_VALUES.find(function (value) { return value.exp === historicalValue.histOperator; })) === null || _a === void 0 ? void 0 : _a.name) || '';
        var duration = getHistoricalDuration(historicalValue);
        return "".concat(operator, " ").concat(historicalValue.histValue, " time(s)").concat(duration);
    };
    var getHistoricalDuration = function (historicalBlock) {
        var _a, _b, _c, _d;
        var from = (_a = historicalBlock.durationFrom) !== null && _a !== void 0 ? _a : 0;
        var to = (_b = historicalBlock.durationTo) !== null && _b !== void 0 ? _b : 0;
        var duration = (_d = parseInt((_c = historicalBlock.duration) !== null && _c !== void 0 ? _c : '')) !== null && _d !== void 0 ? _d : 0;
        var durationUnit = historicalBlock.durationUnit;
        var historicalPluginText = '';
        if (from > 0 && to > 0 && duration <= 0) {
            historicalPluginText += ' between ';
            historicalPluginText += new Date(from * 1000).toLocaleString(undefined, ShortDateFormatOptions);
            historicalPluginText += ' and ';
            historicalPluginText += new Date(to * 1000).toLocaleString(undefined, ShortDateFormatOptions);
        }
        else if (from > 0 && to <= -1 && duration <= 0) {
            historicalPluginText += ' after ';
            historicalPluginText += new Date(from * 1000).toLocaleString(undefined, ShortDateFormatOptions);
        }
        else if (to > 0 && from <= -1 && duration <= 0) {
            historicalPluginText += ' before ';
            historicalPluginText += new Date(to * 1000).toLocaleString(undefined, ShortDateFormatOptions);
        }
        else if (duration > 0) {
            historicalPluginText += " in the past ".concat(duration, " ").concat(durationUnit);
        }
        return historicalPluginText;
    };
    var getParamString = function (pluginKey, attrKey, paramValues) {
        var _a, _b;
        if (paramValues === void 0) { paramValues = []; }
        var pluginParamKeys = (_b = (_a = pluginMap[pluginKey.join('.')]) === null || _a === void 0 ? void 0 : _a.attributes[attrKey]) === null || _b === void 0 ? void 0 : _b.paramKeys;
        if (!pluginParamKeys || !pluginParamKeys.length || !paramValues.length)
            return '';
        var paramString = ' (with parameters: ';
        var paramDescriptors = paramValues.forEach(function (value, i) {
            paramString += i === 0 ? '' : ', ';
            paramString += "".concat(pluginParamKeys[i], " is ").concat(value === '*' ? 'anything' : value);
        });
        paramString += ')';
        return paramString;
    };
    var renderCtxHistoryResultBlock = function (block) {
        var _a, _b, _c;
        var query = historicalQueries === null || historicalQueries === void 0 ? void 0 : historicalQueries.find(function (data) {
            if (block.parameterValues !== undefined) {
                return data.id === block.parameterValues[0];
            }
        });
        var funcType = query === null || query === void 0 ? void 0 : query.function;
        var attributeName = firstToUpperCase((query === null || query === void 0 ? void 0 : query.plugin.attribute) || '');
        var pluginName = firstToUpperCase((query === null || query === void 0 ? void 0 : query.plugin.id.split('.')[2]) || '');
        var opValue = ((_a = CONSTS.INT_FLOAT_STATEMENTS.find(function (statement) { return statement.exp === (query === null || query === void 0 ? void 0 : query.where[0].operator); })) === null || _a === void 0 ? void 0 : _a.value) || '';
        var operator = (_b = getOperatorString(block.nodeId, opValue, (query === null || query === void 0 ? void 0 : query.plugin.attributeType) || '', false)) === null || _b === void 0 ? void 0 : _b.slice(3);
        var conditionValue = query === null || query === void 0 ? void 0 : query.where[0].value.toString();
        var ruleOperator = ((_c = CONSTS.LIMIT_VALUES.find(function (limit) { return limit.exp === block.operator; })) === null || _c === void 0 ? void 0 : _c.name) || 'not exactly';
        var ruleValue = block.value;
        var time = deserializeDuration((query === null || query === void 0 ? void 0 : query.timeRange[0].duration.toString()) || '');
        var parameters = [
            query === null || query === void 0 ? void 0 : query.plugin.parameter1,
            query === null || query === void 0 ? void 0 : query.plugin.parameter2,
            query === null || query === void 0 ? void 0 : query.plugin.parameter3,
            query === null || query === void 0 ? void 0 : query.plugin.parameter4,
            query === null || query === void 0 ? void 0 : query.plugin.parameter5,
        ]
            .filter(function (val) { return val; })
            .join(', ');
        return (React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__row"), key: "$nodeId-".concat(block.nodeId) },
            React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__node-id") }, block.nodeId),
            funcType === 'sum' ? (React.createElement("span", null,
                React.createElement("b", null,
                    firstToUpperCase(ruleOperator),
                    " ",
                    ruleValue,
                    ' '),
                "count(s) of ",
                React.createElement("b", null, attributeName),
                parameters.length !== 0 ? " (".concat(parameters, ") ") : ' ',
                "in total occurred in the last",
                ' ',
                React.createElement("b", null, time === null || time === void 0 ? void 0 :
                    time.duration,
                    " ", time === null || time === void 0 ? void 0 :
                    time.unit,
                    ' '),
                "where",
                ' ',
                React.createElement("b", null,
                    pluginName ? pluginName : '',
                    " ",
                    attributeName,
                    ' '),
                "was",
                ' ',
                React.createElement("b", null,
                    operator,
                    " ",
                    conditionValue))) : (React.createElement("span", null,
                "There ",
                ruleValue === '1' ? 'was ' : 'were ',
                React.createElement("b", null,
                    ruleOperator,
                    " ",
                    ruleValue,
                    ' '),
                ' ',
                "time(s) in the last",
                React.createElement("b", null,
                    ' ', time === null || time === void 0 ? void 0 :
                    time.duration,
                    " ", time === null || time === void 0 ? void 0 :
                    time.unit,
                    ' '),
                "where",
                ' ',
                React.createElement("b", null,
                    pluginName ? pluginName : '',
                    " ",
                    attributeName),
                parameters.length !== 0 ? " (".concat(parameters, ") ") : ' ',
                "was",
                ' ',
                React.createElement("b", null,
                    operator,
                    " ",
                    conditionValue)))));
    };
    var renderConditionBlock = function (block) {
        var _a, _b, _c;
        var pluginString = block.ctxVariable.split('.');
        var pluginKey = pluginString.slice(0, 3);
        // a little redundant, but don't know if historicalValue will be cleaned if
        // the type is swapped out
        var historicalValue = block.type === 'historical' ? block.historicalValue : undefined;
        var locationMetadata = getLocationMetadata(block.attributeName, block.value);
        var attributeName = getAttributeName(pluginKey, block.attributeName, !!locationMetadata, (_a = block === null || block === void 0 ? void 0 : block.hasPlaceHolder) === null || _a === void 0 ? void 0 : _a.contextOrHistorical);
        var pluginName = getPluginName(pluginKey, !!locationMetadata);
        var operator = getOperatorString(block.nodeId, block.operator, block.contextParameterType, (_b = block.hasPlaceHolder) === null || _b === void 0 ? void 0 : _b.name, historicalValue, locationMetadata);
        var conditionValue = getConditionValue(block.value, block.contextParameterType, (_c = block.hasPlaceHolder) === null || _c === void 0 ? void 0 : _c.constant, locationMetadata, block.rules);
        var historicalString = getHistoricalString(historicalValue);
        var paramString = getParamString(pluginKey, block.attributeName, block.parameterValues);
        // not sure if we need finer control over the elements
        return (React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__row"), key: "$nodeId-".concat(block.nodeId) },
            React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__node-id") }, block.nodeId),
            React.createElement("span", null,
                attributeName,
                " ",
                pluginName ? "(".concat(pluginName, ")") : '',
                " ",
                operator,
                " ",
                React.createElement("b", null,
                    " ",
                    conditionValue,
                    " "),
                historicalString,
                paramString)));
    };
    return (React.createElement("div", { className: "".concat(DEFAULT_CLASS, " ").concat(className) },
        uiBlocks.map(function (block, i) {
            return block.category === 'ctxhistory' && block.attributeName === 'result'
                ? renderCtxHistoryResultBlock(block)
                : renderConditionBlock(block);
        }),
        !uiBlocks.length && (React.createElement("div", { className: "no-logic" },
            React.createElement("div", { className: "no-logic__image" },
                React.createElement(EmptyStateIcon, { fill: "currentColor" })),
            React.createElement("div", { className: "no-logic__text" },
                React.createElement("p", null, "No audience constraints exist!"),
                React.createElement("p", null, "Add some rules to add audience constraints"))))));
};
//# sourceMappingURL=RulePreview.js.map